export const emailDataFormatter = (formData: any) => {
  const compName = formData?.companyName + '\n' ?? ''
  const website = formData?.website ?? '' + '\n' ?? ''
  const businessType = formData?.businessType + '\n' ?? ''
  const name = formData?.name + '\n' ?? ''
  const mobile = formData?.mobile + '\n' ?? ''
  const workEmail = formData?.workEmail + '\n' ?? ''

  return `Company Name: ${encodeURIComponent(compName)}
    Website: ${encodeURIComponent(website)}
    Type of Business: ${encodeURIComponent(businessType)}
    Contact person Name: ${encodeURIComponent(name)}
    Contact Number: ${encodeURIComponent(mobile)}
    Email address: ${encodeURIComponent(workEmail)}`
}
